export const iconFontAwesomeAccessibilityAccessibleIcon = (
	<i className="fa-solid fa-accessible-icon"></i>
);
